module.exports = __webpack_public_path__ + "static/adobe-stock-278687681-bb09a85c6e363840a60cbb5d5a0afeb6.jpg";